/**
 * Utility to parse lab value data from markdown format
 */

const parseLabValueData = () => {
  const labValueData = `-------- Serum -------
Serum	Reference Range	SI Reference Interval
Alanine aminotransferase (ALT)	10-40 U/L	10-40 U/L
Aspartate aminotransferase (AST)	12-38 U/L	12-38 U/L
Alkaline phosphatase	25-100 U/L	25-100 U/L
Amylase	25-125 U/L	25-125 U/L
Bilirubin
Total	0.1-1.0 mg/dL	2-17 μmol/L
Direct	0.0-0.3 mg/dL	0-5 μmol/L
Calcium	8.4-10.2 mg/dL	2.1-2.6 mmol/L
Cholesterol
   Total
     Normal	<200 mg/dL	<5.2 mmol/L
     High	>240mg/dL	>6.2 mmol/L
   HDL	40-60 mg/dL	1.0-1.6 mmol/L
   LDL	<160 mg/dL	<4.2 mmol/L
Triglycerides
Normal	<150 mg/dL	<1.70 mmol/L
Borderline	151-199 mg/dL	1.71-2.25 mmol/L
Cortisol
0800 h	5-23 μg/dL	138-635 nmol/L
1600 h	3-15 μg/dL	82-413 nmol/L
2000 h	<50% of 0800 h	Fraction of 0800 h: <0.50
Creatine kinase
Male	25-90 U/L	25-90 U/L
Female	10-70 U/L	10-70 U/L
Creatinine	0.6-1.2 mg/dL	53-106 μmol/L
Urea nitrogen	7-18 mg/dL	1.2-3.0 mmol/L
Electrolytes, serum
Sodium (Na+)	136-146 mEq/L	136-146 mmol/L
Potassium (K+)	3.5-5.0 mEq/L	3.5-5.0 mmol/L
Chloride (Cl-)	95-105 mEq/L	95-105 mmol/L
Bicarbonate (HCO3-)	22-28 mEq/L	22-28 mmol/L
Magnesium (Mg2+)	1.5-2.0 mEq/L	0.75-1.0 mmol/L
Ferritin
Male:	20-250 ng/mL	20-250 μg/L
Female:	10-120 ng/mL	10-120 μg/L
Follicle-stimulating hormone
Male	4-25 mIU/mL	4-25 U/L
Female
   premenopause	4-30 mIU/mL	4-30 U/L
   midcycle peak	10-90 mIU/mL	10-90 U/L
   postmenopause	40-250 mIU/mL	40-250 U/L
Glucose
Fasting	70-110 mg/dL	3.8-5.6 mmol/L
Random, non-fasting	<140 mg/dL	<7.7 mmol/L
Growth hormone- arginine stimulation
Fasting	<5 ng/mL	<5 μg/L
Provocative stimuli	>7 ng/mL	>7 μg/L
Iron
Male	65-175 μg/dL	11.6-31.3 μmol/L
Female	50-170 μg/dL	9.0-30.4 μmol/L
Total iron-binding capacity	250-400 μg/dL	44.8-71.6 μmol/L
Transferrin	200-360 mg/dL	2.0-3.6 g/L
Lactate dehydrogenase	45-200 U/L	45-200 U/L
Luteinizing hormone
Male	6-23 mIU/mL	6-23 U/L
Female
   follicular phase	5-30 mIU/mL	5-30 U/L
   midcycle	75-150 mIU/mL	75-150 U/L
   postmenopause	30-200 mIU/mL	30-200 U/L
Osmolality	275-295 mOsmol/kg H2O	275-295 mOsmol/kg H2O
Intact parathyroid hormone (PTH)	10-60 pg/mL	10-60 ng/mL
Phosphorus (inorganic)	3.0-4.5 mg/dL	1.0-1.5 mmol/L
Prolactin (hPRL)
Male	<17 ng/mL	<17 μg/L
Female	<25 ng/mL	<25 μg/L
Proteins
   Total	6.0-7.8 g/dL	60-78 g/L
   Albumin	3.5-5.5 g/dL	35-55 g/L
   Globulin	2.3-3.5 g/dL	23-35 g/L
Troponin I	<0.04 ng/dL	<0.04 μg/L
TSH	0.4-4.0 μU/mL	0.4-4.0 μU/mL
Thyroidal iodine (123I) uptake	8%-30% of administered dose/24 h	0.08-0.30/24 h
Thyroxine (T4)	5-12 μg/dL	64-155 nmol/L
Free (T4)	0.9-1.7 ng/dL	12.0-21.9 pmol/L
Triiodothyronine (T3) (RIA)	100-200 ng/dL	1.5-3.1 nmol/L
Triiodothyronine (T3) resin uptake	25%-35%	0.25-0.35
Uric acid	3.0-8.2 mg/dL	0.18-0.48 mmol/L
Immunoglobulins
IgA	76-390 mg/dL	0.76-3.90 g/L
IgE	0-380 IU/mL	0-380 kIU/L
IgG	650-1500 mg/dL	6.5-15.0 g/L
IgM	50-300 mg/dL	0.5-3.0 g/L
Gases, arterial blood (room air)
pH	7.35-7.45	[H+] 36-44 nmol/L
Pco2	33-45 mm Hg	4.4-5.9 kPa
Po2	75-105 mm Hg	10.0-14.0 kPa


------------ Cerebrospinal --------------
Cerebrospinal Fluid	Reference Range	SI Reference Interval
Cell count	0-5/mm3	0-5 x 106/L
Chloride	118-132 mEq/L	118-132 mmol/L
Gamma globulin	3%-12% total proteins	0.03-0.12
Glucose	40-70 mg/dL	2.2-3.9 mmol/L
Pressure	70-180 mm H2O	70-180 mm H2O
Proteins, total	<40 mg/dL	<0.40 g/L

---------- Blood ---------
Hematologic	Reference Range	SI Reference Interval
Erythrocyte count
Male	4.3-5.9 million/mm3	4.3-5.9 x 1012/L
Female	3.5-5.5 million/mm3	3.5-5.5 x 1012/L
Erythrocyte sedimentation rate (Westergren)
Male	0-15 mm/h	0-15 mm/h
Female	0-20 mm/h	0-20 mm/h
Hematocrit
Male	41%-53%	0.41-0.53
Female	36%-46%	0.36-0.46
Hemoglobin, blood
Male	13.5-17.5 g/dL	135-175 g/L
Female	12.0-16.0 g/dL	120-160 g/L
Hemoglobin A1c	≤6%	≤42 mmol/mol
Hemoglobin, plasma	<4 mg/dL	<0.62 mmol/L
Leukocyte count (WBC)	4500-11,000/mm3	4.5-11.0 x 109/L
Neutrophils, segmented	54%-62%	0.54-0.62
Neutrophils, bands	3%-5%	0.03-0.05
Eosinophils	1%-3%	0.01-0.03
Basophils	0%-0.75%	0.00-0.0075
Lymphocytes	25%-33%	0.25-0.33
Monocytes	3%-7%	0.03-0.07
CD4+ T-lymphocyte count	≥500/mm3	≥0.5 x 109/L
Platelet count	150,000-400,000/mm3	150-400 x 109/L
Reticulocyte count	0.5%-1.5%	0.005-0.015
D-Dimer	≤250 ng/mL	≤1.4 nmol/L
Partial thromboplastin time (PTT)(activated)	25-40 seconds	25-40 seconds
Prothrombin time (PT)	11-15 seconds	11-15 seconds
Mean corpuscular hemoglobin (MCH)	25-35 pg/cell	0.39-0.54 fmol/cell
Mean corpuscular hemoglobin concentration (MCHC)	31%-36% Hb/cell	4.8-5.6 mmol Hb/L
Mean corpuscular volume (MCV)	80-100 μm3	80-100 fL
Volume
Plasma
   Male	25-43 mL/kg	0.025-0.043 L/kg
   Female	28-45 mL/kg	0.028-0.045 L/kg
Red cell
   Male	20-36 mL/kg	0.020-0.036 L/kg
   Female	19-31 mL/kg	0.019-0.031 L/kg
-------- Urine and BMI ----------------
Urine	Reference Range	SI Reference Intervals
Calcium	100-300 mg/24 h	2.5-7.5 mmol/24 h
Creatinine clearance
Male	97-137 mL/min	97-137 mL/min
Female	88-128 mL/min	88-128 mL/min
Osmolality	50-1200 mOsmol/kg H2O	50-1200 mmol/kg
Oxalate	8-40 μg/mL	90-445 μmol/L
Proteins, total	<150 mg/24 h	<0.15 g/24 h
17-Hydroxycorticosteroids
Male	3.0-10.0 mg/24 h	8.2-27.6 μmol/24 h
Female	2.0-8.0 mg/24 h	5.5-22.0 μmol/24 h
17-Ketosteroids, total
Male	8-20 mg/24 h	28-70 μmol/24 h
Female	6-15 mg/24 h	21-52 μmol/24 h
Body Mass Index (BMI)	Adult: 19-25 kg/m2`;

  const sections = labValueData.split(/-+ .* -+/).filter(section => section.trim());

  const parseSection = (sectionText, sectionName) => {
    const lines = sectionText.trim().split('\n').filter(line => line.trim());

    // Helper function to get indentation level
    const getIndentLevel = (line) => {
      const match = line.match(/^(\s*)/);
      return match ? match[1].length : 0;
    };

    // Helper function to create test object
    const createTest = (name, referenceRange = '', siInterval = '') => ({
      name,
      referenceRange,
      siInterval,
      subTests: []
    });

    let rootTests = [];
    let currentParents = []; // Stack to track parent hierarchy

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;

      // Skip header lines
      if (line.includes('Reference Range') || line.includes('SI Reference Interval')) continue;

      const parts = line.split('\t');
      const fullTestName = parts[0] || '';
      const referenceRange = parts[1]?.trim() || '';
      const siInterval = parts[2]?.trim() || '';

      const indentLevel = getIndentLevel(lines[i]);
      const cleanTestName = fullTestName.trim();

      // Determine the level based on indentation
      const level = Math.floor(indentLevel / 2); // 0 spaces = level 0, 2 spaces = level 1, 4 spaces = level 2

      // Create the test object
      const testObj = createTest(cleanTestName, referenceRange, siInterval);

      if (level === 0) {
        // Root level test
        rootTests.push(testObj);
        currentParents = [testObj];
      } else {
        // Find the appropriate parent
        while (currentParents.length > level) {
          currentParents.pop();
        }

        if (currentParents.length > 0) {
          const parent = currentParents[currentParents.length - 1];
          parent.subTests.push(testObj);
          currentParents.push(testObj);
        }
      }
    }

    return rootTests;
  };

  const result = {
    serum: parseSection(sections[0], 'Serum'),
    cerebrospinal: parseSection(sections[1], 'Cerebrospinal'),
    blood: parseSection(sections[2], 'Blood'),
    urine: parseSection(sections[3], 'Urine and BMI')
  };

  return result;
};

export default parseLabValueData;